import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export const CardWrapper = styled.div`
    background: ${props => props.type === 'employee' ? '#00abb6' : '#f5f5f5'};
    border: ${props => props.type === 'employee' ? null : '1px solid #707070'};
    border-radius: ${props => props.type === 'employee' ? '30px' : '15px'};
    margin-bottom: 10px;
    width: ${props => props.type === 'employee' ? '15vw' : '9vw'}; 
    padding: 20px;
    text-align: center;
    vertical-align: middle;
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: space-evenly;
    &:hover{
        transform: scale(1.1);
        filter: brightness(120%);
        & a {
            font-weight: 300;
            font-size: 20;
        }
    }
`
export const LinkWrapper = styled(Link)`
    text-decoration: none;
    font: 18px Open Sans, Helvetica, sans-serif;
    color: ${props => props.type === 'employee' ? 'white' : '#707070'};
    letter-spacing: 1px;
    font-weight: 100;
`
const ImageWrapper = styled.div`
    width: 30px;
    height: 30px;
    background-repeat: no-repeat;
    background-image: url(${ props => props.img});
    background-position: center; 
    background-size: cover;
    border-radius: 50%;
`

const CompanyItemCard = ({ onClick, name, type, img }) => {
        let value;
        if( name === Object(name)){
            value = '';
            Object.keys(name).forEach( key => value = `${value} ${name[key]}`);
        } else {
            value = name;
        }

        let imageContent = null;
        if(img){
            imageContent = img;
        }
        return(
            <CardWrapper 
                type={type} 
                onClick={onClick}
            >   
                { img ? <ImageWrapper img={img} /> : null}
                <LinkWrapper 
                    to={`/company/${type}Editor`}
                    type={type}     
                > 
                    {value}
                </LinkWrapper>
            </CardWrapper>
        )
}

CompanyItemCard.propTypes = {
    /** Name displayed on the card, could also receive an object to be displayed */
    name: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    /** Type of the card, used for the router link and css */
    type: PropTypes.string.isRequired,
    /** Object passed in for auto-filling information */
    onClick: PropTypes.func,
};


CompanyItemCard.defaultProps = {
    name: 'Unknown',
    type: 'Unknown',
    onClick: () => null
};

export default CompanyItemCard;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/CompanyItemCard.jsx